/**
 * Inline banner shown above the composer when the conversations listener fails
 * (e.g. missing Firestore permissions). Renders nothing when there is no error.
 */
import { CircleAlert } from 'lucide-react'

export function ChatComposerError({ error }: { error: string | null }) {
  if (!error) return null
  return (
    <div className="border-destructive/40 bg-destructive/10 text-destructive mb-2 flex items-start gap-2 rounded-lg border px-3 py-2 text-xs">
      <CircleAlert className="mt-0.5 size-3.5 shrink-0" />
      <span>Não foi possível carregar as conversas: {error}</span>
    </div>
  )
}
